module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f00iv-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("W. F. OSCAR FEDERHEN")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("Postwar portrait from a composite photograph with portraits of 116 members of the John A. Logan Post No. 127 of the Grand Army of the Republic in Salina, Kansas, c. 1911.")]), _vm._v(" "), _c('p', {
    staticClass: "fm2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Smoky Hill Museum Object Identification Number 1946.12.1. Donated by")])]), _vm._v(" "), _c('p', {
    staticClass: "fm3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Cora Walker Shelton to the Smoky Hill Museum, Salina, Kansas.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a11a6dfe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_FM1.vue
// module id = 66
// module chunks = 0